var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.6667C0 9.7005 9.7005 0 21.6667 0C33.6328 0 43.3333 9.7005 43.3333 21.6667C43.3333 33.6328 33.6328 43.3333 21.6667 43.3333C9.7005 43.3333 0 33.6328 0 21.6667ZM16.3157 14.0176C15.6811 13.383 14.6522 13.383 14.0176 14.0176C13.383 14.6522 13.383 15.6811 14.0176 16.3157L19.3686 21.6667L14.0176 27.0176C13.383 27.6522 13.383 28.6811 14.0176 29.3157C14.6522 29.9503 15.6811 29.9503 16.3157 29.3157L21.6667 23.9648L27.0176 29.3157C27.6522 29.9503 28.6811 29.9503 29.3157 29.3157C29.9503 28.6811 29.9503 27.6522 29.3157 27.0176L23.9648 21.6667L29.3157 16.3157C29.9503 15.6811 29.9503 14.6522 29.3157 14.0176C28.6811 13.383 27.6522 13.383 27.0176 14.0176L21.6667 19.3686L16.3157 14.0176Z",
    fill: "#EB2E25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTransaction);
export default __webpack_public_path__ + "static/media/failed-transaction.d9685ce633f67f476e64c967883952f6.svg";
export { ForwardRef as ReactComponent };